/* SCK call-center channel marker. See ../README.md.
 * ?channel=callcenter sets a cookie; while the cookie exists the cart attribute
 * _channel is kept at "call_center" so Shopify Flow can tag the order.
 * ?channel=clear removes the cookie and the attribute. All failures are swallowed. */
(function () {
  'use strict';
  var COOKIE = 'cc_channel';
  var VALUE = 'call_center';
  var ATTR = '_channel';
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?$/;
  var DEBOUNCE_MS = 300;
  var timer = null;
  var busy = false;
  var queued = false;
  var origFetch = null;

  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (typeof r !== 'string' || !r) return '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function readCookie() {
    var parts = String(document.cookie || '').split('; ');
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf(COOKIE + '=') === 0) return parts[i].slice(COOKIE.length + 1);
    }
    return null;
  }

  function writeAttr(value) {
    var body = { attributes: {} };
    body.attributes[ATTR] = value;
    return origFetch.call(window, root() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  // Single-flight: one run at a time; requests during a run queue one follow-up.
  function apply() {
    if (busy) { queued = true; return; }
    busy = true;
    function done() {
      busy = false;
      if (queued) { queued = false; apply(); }
    }
    try {
      if (readCookie() !== VALUE) { done(); return; }
      origFetch.call(window, root() + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (res) {
        return res.json();
      }).then(function (cart) {
        var cur = cart && cart.attributes ? cart.attributes[ATTR] : undefined;
        if (cur !== VALUE) return writeAttr(VALUE);
      }).catch(function () {}).then(done);
    } catch (e) { done(); }
  }

  function schedule() {
    try {
      if (timer !== null) clearTimeout(timer);
      timer = setTimeout(function () { timer = null; apply(); }, DEBOUNCE_MS);
    } catch (e) {}
  }

  function isCartMutation(input) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || String(input);
      return CART_MUTATION.test(new URL(url, location.href).pathname);
    } catch (e) {
      return false;
    }
  }

  function wrapFetch() {
    var orig = origFetch;
    window.fetch = function (input) {
      var p = orig.apply(this, arguments);
      try {
        if (isCartMutation(input)) p.then(schedule, schedule);
      } catch (e) {}
      return p;
    };
  }

  try {
    if (typeof window.fetch !== 'function') return;
    origFetch = window.fetch;

    var param = new URLSearchParams(location.search).get('channel');
    if (param === 'callcenter') {
      document.cookie = COOKIE + '=' + VALUE + '; max-age=15552000; path=/; SameSite=Lax; Secure';
    } else if (param === 'clear') {
      document.cookie = COOKIE + '=; max-age=0; path=/; SameSite=Lax; Secure';
      writeAttr('').catch(function () {});
    }

    if (readCookie() === VALUE) {
      wrapFetch();
      apply();
      window.addEventListener('pageshow', schedule);
    }
  } catch (e) {}
})();